module.exports = __webpack_public_path__ + "img/tech1.03a02a29.jpg";